<template>
    <v-form v-model="valid" ref="form">
        <v-dialog v-model="deleteDialog" persistent max-width="320">
            <v-card>
                <v-card-title class="headline">Delete this file?</v-card-title>
                <v-card-text>Are you sure you would like to do this?</v-card-text>
                <v-card-actions class="pa-3">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="deleteDialog = false">Cancel</v-btn>
                    <v-btn color="error" :loading="loading" @click="delFile(deleteFile)">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card class="pt-3 container">
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-row>

                        <v-col md="12">
                            <v-row class="align-center justify-space-between">
                                <v-col cols="4">
                                    <v-card-title>
                                        <span class="headline">Folder</span>
                                    </v-card-title>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn @click="add()" color="primary"
                                        style="width: 85%; padding: 8px 10px 8px 10px; margin-left: 15%;">
                                        <v-icon large class="mr-2" color="white">mdi-plus
                                        </v-icon>
                                        Tambah File
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-card-text>
                                <v-data-table id="folder-table" :loading="loading" :headers="headers" :items="metaFiles"
                                    :no-data-text="$t('no_data')">
                                    <template v-slot:item.action="{item}">
                                        <v-icon class="mr-2" color="primary"
                                            @click="seeDetail(item), fileUpload = null">mdi-pencil
                                        </v-icon>
                                        <v-icon color="error" @click="delDialog(item)">mdi-delete</v-icon>
                                    </template>
                                    <template v-slot:item.name="{item}">
                                        <v-row v-if="item.contentType === `application/pdf`"
                                            class="align-center hover-folder" @click="downloadFile(item)">
                                            <img style="margin-right: 5px;" src="img/image_folder/pdf.png">
                                            {{ item.name }}
                                        </v-row>
                                        <v-row @click="downloadFile(item)"
                                            v-else-if="item.contentType === `application/vnd.openxmlformats-officedocument.spreadsheetml.sheet` || item.contentType === `application/vnd.ms-excel`"
                                            class="align-center hover-folder">
                                            <img style="margin-right: 5px;" src="img/image_folder/excel.png">
                                            {{ item.name }}
                                        </v-row>
                                        <v-row @click="downloadFile(item)"
                                            v-else-if="item.contentType === `jpeg/image` || item.contentType === `image/jpeg` || item.contentType === `png/image` || item.contentType === `image/png`"
                                            class="align-center hover-folder">
                                            <img style="margin-right: 5px;" src="img/image_folder/image.svg">
                                            {{ item.name }}
                                        </v-row>
                                        <v-row @click="downloadFile(item)"
                                            v-else-if="item.contentType === `application/vnd.openxmlformats-officedocument.wordprocessingml.document` || item.contentType === `application/vnd.ms-word`"
                                            class="align-center hover-folder">
                                            <img style="margin-right: 5px;" src="img/image_folder/document.png">
                                            {{ item.name }}
                                        </v-row>
                                        <v-row v-else class="align-center hover-folder" @click="downloadFile(item)">
                                            <img style="margin-right: 5px;" src="img/image_folder/others.svg">
                                            {{ item.name }}
                                        </v-row>

                                    </template>
                                    <template v-slot:item.size="{item}">
                                        {{ formatBytes(item.size) }}
                                    </template>
                                    <template v-slot:item.timeCreated="{item}">
                                        {{ formatTime2(item.timeCreated) }}
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-col>

                    </v-row>
                </v-tab-item>

                <v-tab-item>
                    <v-row>
                        <v-col md="6" class="headline">
                            <v-btn icon @click="tab = 0, checkFolder()">
                                <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>{{$t('back')}}
                        </v-col>
                        <v-col md="6" class="text-right" v-if="isEdit">
                        </v-col>
                        <v-col md="12">
                            <v-text-field :disabled="isEdit" label="Nama File" v-model="detail.name" type="text"
                                :rules="[...rules, validator.alfaNumberNotRequired]" required class="sae-required">
                            </v-text-field>
                        </v-col>
                        <v-col md="12">
                            <span style=" font-size: 12px; color: #686868;">Unggah File</span>
                            <v-file-input :rules="fileRules" :class="fileUpload ? checkType(fileUpload) : ''"
                                label="Unggah file di sini" v-model="fileUpload" prepend-icon="mdi-plus">
                            </v-file-input>
                        </v-col>
                        <v-col md="12" class="text-center">
                            <v-btn color="primary" class="ma-2" :loading="loading" :disabled="!valid"
                                @click="updateUpload(detail)" v-if="isEdit">Update File</v-btn>
                            <v-btn v-else color="primary" class="ma-2" :loading="loading" :disabled="!valid"
                                @click="submitUpload">Tambah File</v-btn>
                        </v-col>
                    </v-row>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
    </v-form>
</template>

<script>
    import moment from 'moment'
    import firebase from "firebase";
    import ENV from "./../../../../store/modules/environtment";

    export default {
        props: ['userId', 'contactList'],
        name: "Emergency-Contact-List",
        data() {
            return {
                headers: [{
                        text: 'Nama File',
                        value: "name",
                        width: '40%'
                    },
                    {
                        text: 'Tanggal Upload',
                        value: "timeCreated"
                    },
                    {
                        text: 'Ukuran File',
                        value: "size",

                    },
                    {
                        text: "",
                        value: "action"
                    },
                ],
                fileRules: [(file) => (file.size < 104857000 || 'File terlalu besar, maksimum 100 MB!')],
                rules: [(value) => (value === 0 ? true : !!value || this.$i18n.t('required'))],
                rules2: [(value) => (value == 0 ? true : value ? value > 0 : !!value || this.$i18n.t('required'))],
                rules4: [
                    v => /^[0-9.,]+$/.test(v) || this.$i18n.t('number_required'),
                    (value) => (value === 0 ? true : !!value || this.$i18n.t('required'))
                ],
                validator: this.$store.state.validator,
                baseUrl: this.$store.state.baseUrl,
                valid: false,
                formData: [],
                userIdLogin: this.$store.getters.user.id,
                loading: false,
                tab: 0,
                fileError: false,
                company_id: this.$store.state.company,
                detail: {},
                fileUpload: null,
                isEdit: false,
                metaFiles: [],
                deleteDialog: false,
                delItem: null,
                relationList: [{
                        id: 1,
                        nameId: 'Suami'
                    },
                    {
                        id: 2,
                        nameId: 'Istri'
                    },
                    {
                        id: 3,
                        nameId: 'Ayah'
                    },
                    {
                        id: 4,
                        nameId: 'Ibu'
                    },
                    {
                        id: 5,
                        nameId: 'Anak Pertama'
                    },
                    {
                        id: 6,
                        nameId: 'Anak Kedua'
                    },
                    {
                        id: 7,
                        nameId: 'Anak Keempat'
                    },
                    {
                        id: 8,
                        nameId: 'Anak Kelima'
                    },
                ],

            }
        },
        methods: {
            uploadFile(file) {
                this.fileError = false
                if(file.size > 104857600 ){
                this.fileError = true
                this.fileUpload = null
                this.valid = false
                }
            },

            async downloadFile(item) {
                const download = await firebase.storage().refFromURL(
                    `gs://appsensi-dev.appspot.com/${item.fullPath}`).getDownloadURL().catch(() => {
                    return '-'
                })
                window.open(download, '_blank')
            },
            checkType(item) {
                if (item.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || item
                    .type === "application/vnd.ms-word") {
                    return 'doc-type'
                } else if (item.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || item
                    .type === "application/vnd.ms-excel") {
                    return 'excel-type'
                } else if (item.type === "image/png" || item.type === "jpeg/image" || item.type === "image/jpeg" || item
                    .type === "png/image" || item ===
                    "png/image") {
                    return 'image-type'
                } else if (item.type === "application/pdf") {
                    return 'pdf-type'
                } else if (item.type === undefined || item === null) {
                    return ''
                } else {
                    return 'others-type'
                }
            },
            formatBytes(bytes) {

                if (!+bytes) return '0 Bytes'
                const decimals = 2
                const k = 1024
                const dm = decimals < 0 ? 0 : decimals
                const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

                const i = Math.floor(Math.log(bytes) / Math.log(k))

                return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
            },
            checkFolder() {
                this.metaFiles = []
                const listRef = firebase.storage().ref(`${this.environment}/folder/${this.company_id}/${this.userId}`);
                listRef.listAll()
                    .then((res) => {
                        res.prefixes.forEach((folderRef) => {

                            // eslint-disable-next-line no-console
                            console.log(folderRef, 'folder ref')
                            // All the prefixes under listRef.
                            // You may call listAll() recursively on them.
                        });
                        res.items.forEach((itemRef) => {
                            // eslint-disable-next-line no-console
                            firebase.storage().ref(itemRef.fullPath).getMetadata()
                                .then((metadata) => {

                                    this.metaFiles.push(metadata)

                                })
                                .catch((error) => {
                                    // Uh-oh, an error occurred!
                                    // eslint-disable-next-line no-console
                                    console.log(error, 'error ref')
                                });
                        });

                    }).catch((error) => {
                        // eslint-disable-next-line no-console
                        console.log(error, 'error ref')
                        // Uh-oh, an error occurred!
                    });

            },
            submitUpload() {
                this.loading = true;
                const storageRef = firebase.storage().ref(
                    `${this.environment}/folder/${this.company_id}/${this.userId}/${this.detail.name}`).put(this
                    .fileUpload);
                storageRef.on(`state_changed`, snapshot => {
                        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    }, error => {
                        // eslint-disable-next-line no-console
                        console.log(error.message)
                    },
                    () => {
                        this.uploadValue = 100;
                        this.loading = false;
                        this.showMessage('success', 'File berhasil diunggah')
                        this.tab = 0
                        this.checkFolder()
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            this.img1 = url;
                        });
                    }
                );
            },
            delFile(item) {
                const desertRef = firebase.storage().ref(item.fullPath);

                // Delete the file
                desertRef.delete().then(() => {
                    // eslint-disable-next-line no-console
                    this.checkFolder()
                    this.deleteDialog = false
                    // File deleted successfully
                }).catch((error) => {
                    // eslint-disable-next-line no-console
                    console.log(error)
                    this.checkFolder()
                    this.deleteDialog = false
                    // Uh-oh, an error occurred!
                });
            },
            delDialog(item) {
                this.deleteDialog = true
                this.deleteFile = item
            },
            updateUpload(item) {
                this.loading = true;
                const storageRef = firebase.storage().ref(
                    `${item.fullPath}`).put(this.fileUpload);
                storageRef.on(`state_changed`, snapshot => {
                        this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    }, error => {
                        // eslint-disable-next-line no-console
                        console.log(error.message)
                    },
                    () => {
                        this.uploadValue = 100;
                        this.showMessage('success', 'File berhasil diperbarui')
                        this.loading = false;
                        this.tab = 0
                        this.checkFolder()
                        storageRef.snapshot.ref.getDownloadURL().then((url) => {
                            this.img1 = url;
                            // eslint-disable-next-line no-console
                        });
                    }
                );
            },
            seeDetail(item) {
                this.isEdit = true
                this.detail = item
                this.tab = 1
            },
            add() {
                this.isEdit = false
                this.detail = {
                    userId: this.userId,
                    dateOfBirth: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
                }
                this.tab = 1
                this.fileUpload = null
            },
            costumHeader(actionId, action) {
                return {
                    headers: {
                        actionId,
                        action
                    }
                }
            },
            formatTime(date) {
                return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY")
            },

            formatTime2(date) {
                return moment(date).locale(this.$i18n.t('lang')).format("DD MMM YYYY")
            },
            getParentData() {
                this.formData = this.contactList
            },
            async getRelation() {
                this.loading = true
                this.relationList = await this.$store.dispatch('getRelations')
                this.loading = false
            },
            async saveOrUpdate(data) {
                if (this.isEdit) {
                    this.editComponent(data)
                } else {
                    this.saveComponent(data)
                }
            },
            async saveComponent(data) {
                const body = {
                    ...data,
                    relationId: data.relationshipId
                }
                this.loading = true
                const result = await this.$store.dispatch('saveEmergency', body)
                this.loading = false
                if (result) {
                    this.showMessage('success', this.$i18n.t('alert_save'))
                    this.$emit('reload', true)
                    this.tab = 0
                }
            },
            async editComponent(data) {
                const body = {
                    ...data,
                    relationId: data.relationshipId
                }
                this.loading = true
                const result = await this.$store.dispatch('editEmergency', body)
                this.loading = false
                if (result) {
                    this.showMessage('success', this.$i18n.t('alert_save'))
                    this.$emit('reload', true)
                    this.tab = 0
                }
            },
           
            deleteItem() {
                this.deleteDialog = true;
            },
            showMessage(type, msg) {
                this.$store.dispatch('nShowMessage', {
                    type,
                    msg
                })
            },
            refreshData() {
                if (this.contactList) {
                    this.formData = this.contactList
                } else {
                    this.formData = []
                    this.detail = {
                        dateOfBirth: moment().locale(this.$i18n.t('lang')).format('YYYY-MM-DD')
                    }
                }
            },
        },
        computed: {
            environment() {
                if (ENV.EnvUsed == 'staging')
                    return 'staging'
                else if (ENV.EnvUsed == 'dev') {
                    return 'development'
                } else {
                    return 'production'
                }
            },
        },
        created() {
            this.getParentData()
            this.getRelation()
            this.checkFolder()
        },
        watch: {
            contactList() {
                this.formData = this.contactList
                this.tab = 0
                this.detail = {}
            },
            userId() {
                this.refreshData()
            },

        }
    }
</script>
<style scoped>
    #folder-table>>>tr:hover {
        background: transparent !important;
    }

    .hover-folder:hover {
        cursor: pointer;
        background: transparent !important;
    }

    .sae-grey {
        background: #7c8a963d;
        line-height: 35px;
        cursor: pointer;
    }
</style>
<style>
    .doc-type .v-file-input__text::before {
        content: "";
        background-image: url(/img/image_folder/document.png);
        width: 24px;
        height: 24px;
        display: block;
    }

    .excel-type .v-file-input__text::before {
        content: "";
        background-image: url(/img/image_folder/excel.png);
        width: 24px;
        height: 24px;
        display: block;
    }

    .pdf-type .v-file-input__text::before {
        content: "";
        background-image: url(/img/image_folder/pdf.png);
        width: 24px;
        height: 24px;
        display: block;
    }

    .image-type .v-file-input__text::before {
        content: "";
        background-image: url(/img/image_folder/image.svg);
        width: 24px;
        height: 24px;
        display: block;
    }

    .others-type .v-file-input__text::before {
        content: "";
        background-image: url(/img/image_folder/others.svg);
        width: 24px;
        height: 24px;
        display: block;
    }
</style>